import { ProgressLoaderContent } from "@/shared/components/ProgressLoader";

type AppStartupScreenProps = {
  message?: string;
  title?: string;
};

export default function AppStartupScreen({
  title = "Loading Carevinco",
  message = "Preparing your care workspace...",
}: AppStartupScreenProps) {
  return (
    <div aria-busy="true" aria-live="polite" className="app-startup-screen" role="status">
      <div className="app-startup-card">
        <ProgressLoaderContent message={message} title={title} />
      </div>
    </div>
  );
}
